import "bootstrap/dist/css/bootstrap.min.css";
import './FwdHeader.css';
// import LanguagePicker from '../../common/components/LanguagePicker';

export default function FwdHeader() {
    return (
        <div className="fwd-header"> </div>
    )
}
